export default __webpack_public_path__ + "static/media/MarketRealCase1-en.e856baa3.jpg";